import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { SelectOption } from '../RadioButton/radiobutton-edit';
import { MultiRadioButtonCPanelComponent } from './customizationPanel';

export interface MultiRadioGroup {
  /** Stable, unique-within-widget key used as the answer object key. */
  key: string;
  label: string;
  defaultValue: string | number;
  options: SelectOption[];
}

export interface MultiRadioButtonCustomization {
  description: string;
  groups: MultiRadioGroup[];
  /** Single cap for the whole widget; also acts as the widget weight. */
  cap: number;
  showIfRule: string;
  autocompleteRule: string;
  required: boolean;
}

@Component({
  selector: 'lib-multi-radiobutton-edit',
  imports: [RadioButtonModule, MultiRadioButtonCPanelComponent, FormsModule],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-multi-radiobutton-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full flex-col gap-3">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        @for (
          group of widget.customization.groups;
          track group.key;
          let g = $index
        ) {
          <div class="flex flex-col gap-1">
            <span class="font-medium">{{ group.label }}</span>
            <div [class]="'p-fluid flex flex-wrap' + topologyStyle">
              @for (
                option of group.options;
                track option.value;
                let i = $index
              ) {
                <div class="flex flex-row items-center gap-2">
                  <p-radioButton
                    [autofocus]="false"
                    [value]="option.value"
                    [ngModel]="group.defaultValue"
                    [disabled]="true"
                    inputId="{{ widgetService.uniqueId }}-{{ g }}-{{ i }}"
                  ></p-radioButton>
                  <label for="{{ widgetService.uniqueId }}-{{ g }}-{{ i }}">
                    {{ option.label }}
                    ({{ widgetService.getWeightedPoints(option.weight)() }} pt)
                  </label>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class MultiRadioButtonComponent {
  public dragDropService = inject(DragDropService);
  protected widgetService = inject(
    WidgetService<MultiRadioButtonCustomization>,
  );

  protected topologyStyle = ' flex-row gap-5';
}
